import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import TopSideBar from '../../components/TopSideBar'
import TitlebarAction from '../../components/common/TitlebarActions'
import { PADDING_BASE } from '../../assets/Styles'
import PageContainer from '../../components/common/PageContainer'
import { useProject } from '../../context/ProjectContext'
import ProjectSettings from '../../components/ProjectSettings'

interface ProjectSettingsPage {
  setBlockScreen: (p: boolean) => void
}

const ProjectSettingsPage: React.FC<ProjectSettingsPage> = ({ setBlockScreen }) => {
  const { isProjectUndefined } = useProject();

  return <>
    <TopSideBar currentSection='project-settings' />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="400">
            Administración
          </Typography>
          <Typography color="darkgreen" fontFamily="Poppins" fontWeight="600">
            Proyecto
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction title='Configuración de Proyecto' />

      {!isProjectUndefined() && (
        <ProjectSettings setBlockScreen={setBlockScreen} />
      )}

    </PageContainer>
  </>
}

export default ProjectSettingsPage;